var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ viewBox: "0 0 18 9" }, props),
    React.createElement("path", { fill: "#969EA2", fillRule: "evenodd", d: "M15.37 2.63A9.005 9.005 0 0 0 6.98.23c-.2.04-.26.31-.1.44L9.64 3c.03.02.07.04.12.05 1.32.16 2.53.75 3.49 1.7A5.994 5.994 0 0 1 15 8.76c0 .13.099.24.24.24h2.5c.14 0 .26-.12.26-.26a9.07 9.07 0 0 0-2.63-6.11zM8.91 5.01L3.68.59a.788.788 0 0 0-.5-.18c-.19 0-.39.08-.54.23a.758.758 0 0 0-.05 1.04l4.42 5.23c-.03.54.17 1.09.58 1.5a2.002 2.002 0 0 0 2.83-2.83c-.41-.41-.96-.61-1.51-.57zM1.92 3.99c-.111-.13-.321-.12-.41.02A9.026 9.026 0 0 0 0 8.74c0 .14.12.26.26.26h2.5A.23.23 0 0 0 3 8.76c.04-.859.25-1.71.65-2.49a.212.212 0 0 0-.03-.26l-1.7-2.02z" })
  );
});